module.exports = __webpack_public_path__ + "img/edit1.c944043e.svg";